import React, { useEffect, useRef, useState } from "react";
import CustomInput from "../../Input";
import {
  MinMaxContainer,
  MinMaxPlaceholder,
  PlaceholderInput,
  RangeInput,
  SliderContainer,
  SliderTrack,
  Title,
  Tooltip,
  TooltipArrow,
} from "./index.styled";
import { viewSizeCalculator } from "../../../utils";
import { ErrorMessage } from "../../Input/index.styled";
import { ReactComponent as ErrorInfo } from "../../../Assets/Icons/ErrorInfo.svg";

const DualRangeSlider = ({
  minValueProp,
  maxValueProp,
  title,
  unit,
  showMinMaxFields,
  onChange,
  minValueName,
  maxValueName,
  filteredData,
  step,
  disabled,
}) => {
  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");
  const [showMinTooltip, setShowMinTooltip] = useState(false);
  const [showMaxTooltip, setShowMaxTooltip] = useState(false);
  const [minError, setMinError] = useState(false);
  const [maxError, setMaxError] = useState(false);

  useEffect(() => {
    setMinValue(filteredData?.[minValueName] ?? minValueProp);
    setMaxValue(filteredData?.[maxValueName] ?? maxValueProp);
  }, [filteredData, minValueProp, maxValueProp]);

  const sliderContainerRef = useRef(null);

  const min = minValueProp;
  const max = maxValueProp;

  const handleMinChange = (e) => {
    const value = Math.min(parseFloat(e.target.value), maxValue - 0.01);
    setMinValue(value);
    setMinError(false);
    onChange && onChange(minValueName, value);
  };

  const handleMaxChange = (e) => {
    const value = Math.max(parseFloat(e.target.value), minValue + 0.01);
    setMaxValue(value);
    setMaxError(false);
    onChange && onChange(maxValueName, value);
  };

  const handleMinInputChange = (_, value) => {
    const cleanedValue = value.replace(/[^0-9.]/g, "");
    setMinValue(cleanedValue);
    // Propagate an empty string (not NaN) when the field is cleared so the
    // parent filtered state stays clean.
    onChange &&
      onChange(minValueName, cleanedValue === "" ? "" : parseFloat(cleanedValue));
  };

  const handleMaxInputChange = (_, value) => {
    const cleanedValue = value.replace(/[^0-9.]/g, "");
    setMaxValue(cleanedValue);
    onChange &&
      onChange(maxValueName, cleanedValue === "" ? "" : parseFloat(cleanedValue));
  };

  const handleMinBlur = () => {
    setMinError(false);
    // Keep an empty field empty. Coercing a blank value into a number is what
    // produced the spurious "-1" flash (e.g. "" - 1).
    if (minValue === "" || minValue === null || minValue === undefined) return;
    const minInput = Number(minValue);
    if (isNaN(minInput)) {
      setMinValue("");
      onChange && onChange(minValueName, "");
      return;
    }
    // Normalize the display to a number and keep parent state in sync. The
    // min > max case is surfaced via the error message / apply validation
    // rather than silently clamping against a possibly-empty counterpart.
    setMinValue(minInput);
    onChange && onChange(minValueName, minInput);
  };

  const handleMaxBlur = () => {
    setMaxError(false);
    if (maxValue === "" || maxValue === null || maxValue === undefined) return;
    const maxInput = Number(maxValue);
    if (isNaN(maxInput)) {
      setMaxValue("");
      onChange && onChange(maxValueName, "");
      return;
    }
    setMaxValue(maxInput);
    onChange && onChange(maxValueName, maxInput);
  };

  const getPercent = (value) => ((value - min) / (max - min)) * 100;

  const calculateTooltipPosition = (value) => {
    if (!sliderContainerRef.current) return "0%";

    const sliderWidth = sliderContainerRef.current.offsetWidth;
    const thumbWidth = 16;

    const percentage = ((value - min) / (max - min)) * 100;

    const adjustedPercentage =
      (percentage * (sliderWidth - thumbWidth)) / sliderWidth + 2.4;

    return `${adjustedPercentage}%`;
  };

  return (
    <SliderContainer ref={sliderContainerRef}>
      <Title disabled={disabled}>{title}</Title>
      {/* <div style={{ position: "relative", marginTop: viewSizeCalculator(0.1) }}>
        <RangeInput
          type="range"
          min={min}
          max={max}
          value={minValue}
          step={step}
          onChange={handleMinChange}
          zIndex={3}
          onMouseEnter={() => setShowMinTooltip(true)}
          onMouseLeave={() => setShowMinTooltip(false)}
        />

        {showMinMaxFields ? (
          showMinTooltip && (
            <Tooltip style={{ left: calculateTooltipPosition(minValue) }}>
              <span>
                {unit === "%"
                  ? `${minValue.toLocaleString()} ${unit}`
                  : `${unit} ${minValue.toLocaleString()}`}
              </span>
              <TooltipArrow />
            </Tooltip>
          )
        ) : (
          <Tooltip style={{ left: calculateTooltipPosition(minValue) }}>
            <span>
              {unit} {minValue.toLocaleString()}
            </span>
            <TooltipArrow />
          </Tooltip>
        )}

        <RangeInput
          type="range"
          min={min}
          max={max}
          value={maxValue}
          onChange={handleMaxChange}
          step={step}
          zIndex={2}
          onMouseEnter={() => setShowMaxTooltip(true)}
          onMouseLeave={() => setShowMaxTooltip(false)}
        />

        {showMinMaxFields ? (
          showMaxTooltip && (
            <Tooltip style={{ left: calculateTooltipPosition(maxValue) }}>
              <span>
                {unit === "%"
                  ? `${maxValue.toLocaleString()} ${unit}`
                  : `${unit} ${maxValue.toLocaleString()}`}
              </span>
              <TooltipArrow />
            </Tooltip>
          )
        ) : (
          <Tooltip style={{ left: calculateTooltipPosition(maxValue) }}>
            <span>
              {unit} {maxValue.toLocaleString()}
            </span>
            <TooltipArrow />
          </Tooltip>
        )}

        <SliderTrack
          style={{
            left: `${getPercent(minValue)}%`,
            right: `${100 - getPercent(maxValue)}%`,
          }}
        />
      </div> */}

      {showMinMaxFields ? (
        <MinMaxContainer>
          <CustomInput
            placeholder={unit ? `${unit} Min` : "Min"}
            type="text"
            name="min"
            label={unit ? `${unit} Min` : "Min"}
            disabled={disabled}
            // value={
            //   minValue !== ""
            //     ? unit
            //       ? `${unit} ${minValue.toLocaleString()}`
            //       : `${minValue.toLocaleString()}`
            //     : ""
            // }
            value={minValue}
            onChange={handleMinInputChange}
            onBlur={handleMinBlur}
            error={minError}
            height={2.2}
          />
          <CustomInput
            placeholder={unit ? `${unit} Max` : "Max"}
            type="text"
            name="max"
            label={unit ? `${unit} Max` : "Max"}
            disabled={disabled}
            // value={
            //   maxValue !== ""
            //     ? unit
            //       ? `?${unit} ${maxValue.toLocaleString()}`
            //       : `${maxValue.toLocaleString()}`
            //     : ""
            // }
            value={maxValue}
            onChange={handleMaxInputChange}
            onBlur={handleMaxBlur}
            error={maxError}
            height={2.2}
          />
        </MinMaxContainer>
      ) : (
        <MinMaxPlaceholder>
          {/* <p>{minValueProp.toLocaleString()}</p>
          <p>{maxValueProp.toLocaleString()}</p> */}
        </MinMaxPlaceholder>
      )}
      {typeof minValue === 'number' && typeof maxValue === 'number' && minValue > maxValue && <ErrorMessage>
        <ErrorInfo />
        Min value cannot be greater than max value
      </ErrorMessage>}
    </SliderContainer>
  );
};

export default DualRangeSlider;
